import { useSelector } from "react-redux"
import { availableProductsForPageSelector } from "~/redux/state/printServiceProducts"

export const useCurrentAvailableProductsForPage = () => {
  const products = useSelector(availableProductsForPageSelector)

  return { products }
}
